class AutomaticAdvance {
    constructor(anticipoAutomatico, importeDesde, importeHasta,tablaDeudores) {
        this.anticipoAutomatico = anticipoAutomatico;
        this.importeDesde = importeDesde;
        this.importeHasta = importeHasta;
        this.tablaDeudores = tablaDeudores;
    }
}

export default AutomaticAdvance;